/**
 * This component renders the game centre banner
 */

import React from "react";
import TabButton from "../core/TabButton";

const GameCentreBanner = ({ activeTab, handleTabClick }) => {
  return (
    // Dynamic gradient using style defined above
    <div className="w-full homegradient bg-gradient-to-r from-blue-600 to-red-600 border-b-2 border-light-3 dark:border-dark-3 border-b-2 border-light-3 dark:">
      <div className="flex flex-row justify-between items-center border-1 border-white rounded-lg">
        <div className="flex flex-col w-full justify-between items-left border-1 border-blue">
          <div className="flex flex-row w-full justify-center items-center py-2">
            <img src={`/buihamini.png`} alt="BUIHA" className="h-20 w-20" />
            <div className="flex flex-col justify-left items-left xxs:mx-4">
              <h1 className="xxs:text-4xl text-2xl xs:text-5xl pb-1 text-white font-semibold leading-tight text-center">
                Gamecentre
              </h1>
            </div>
          </div>

          {/* Tab switch buttons */}
          <div className="flex flex-row justify-center items-center">
            <TabButton
              tabName="schedule"
              activeTab={activeTab}
              handleTabClick={handleTabClick}
              label="Schedule"
              first={true}
            />
            <TabButton
              tabName="standings"
              activeTab={activeTab}
              handleTabClick={handleTabClick}
              label="Standings"
            />
            <TabButton
              tabName="stats"
              activeTab={activeTab}
              handleTabClick={handleTabClick}
              label="Statistics"
            />
            {/*<TabButton*/}
            {/*  tabName="archive"*/}
            {/*  activeTab={activeTab}*/}
            {/*  handleTabClick={handleTabClick}*/}
            {/*  label="Archive"*/}
            {/*/>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameCentreBanner;
